import React from 'react'
import { AlignmentContext, DefaultAlignment } from '../../../contexts/alignment-context'
import { CtaButtonMetadataProvider, DefaultCtaButtonContext } from '../../../contexts/cta-button-context'
import { ImageContext, oneColSectionResponsiveImageProps } from '../../../contexts/image-context'

import { FeatureHighlightProvider } from '../../../contexts/feature-highlight-context'

import { TypeSectionSingleColumn, CtaDescriptionPosition, CtaDescriptionWidth } from '../../../lib/types'
import { SingleColumnLayout } from '../../layout/single-column'
import { PageSection } from '../../page-section'
import { ContentProps, ContentRenderer, EntryContentProps } from '../../renderer'
import { TabSection } from '../tabs/tab-section'

const SingleColumnSectionContent: React.FC<EntryContentProps<TypeSectionSingleColumn>> = (props) => {
  const {
    structure: {
      fields: { content, alignment },
    },
  } = props

  return (
    <ImageContext.Provider value={oneColSectionResponsiveImageProps}>
      <FeatureHighlightProvider value={{ titleStyle: 'T1' }}>
        <AlignmentContext.Provider value={alignment?.fields ?? DefaultAlignment}>
          <CtaButtonMetadataProvider
            value={{
              ...DefaultCtaButtonContext,
              descriptionWidth: CtaDescriptionWidth.Auto,
              descriptionPosition: CtaDescriptionPosition.Center,
            }}
          >
            <SingleColumnLayout>
              <ContentRenderer structure={content} />
            </SingleColumnLayout>
          </CtaButtonMetadataProvider>
        </AlignmentContext.Provider>
      </FeatureHighlightProvider>
    </ImageContext.Provider>
  )
}

export const SingleColumnSection: React.FC<ContentProps<TypeSectionSingleColumn>> = ({ className, structure }) => {
  const {
    sys,
    fields: { internalName, background, heading, alignment, isRemovedVerticalPadding, backgroundAssetType },
  } = structure

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      className={className}
      alignment={alignment}
      heading={heading}
      background={background}
      isRemovedVerticalPadding={isRemovedVerticalPadding}
      backgroundAssetType={backgroundAssetType}
    >
      <SingleColumnSectionContent structure={structure} />
    </PageSection>
  )
}

export const SingleColumnSectionForTabs: React.FC<ContentProps<TypeSectionSingleColumn>> = ({
  className,
  structure,
}) => {
  const {
    fields: { background, heading, alignment },
  } = structure

  return (
    <TabSection className={className} alignment={alignment} heading={heading} background={background}>
      <SingleColumnSectionContent structure={structure} />
    </TabSection>
  )
}
